import { Text } from '@tremor/react'
import { setAuthHeader } from '../../api/ApiConfig'

export default function LogoutPage() {
    setAuthHeader('')
    localStorage.clear()
    window.location.href = '/'

    return <Text>Logging out</Text>
}
